import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const CompactViewWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: toPx(sharedStyles.Spacings.MEDIUM),
  paddingLeft: toPx(sharedStyles.Spacings.NODE_HORIZONTAL_PADDING),
  paddingBottom: toPx(sharedStyles.Spacings.MEDIUM),
}

export const NormalViewWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  paddingTop: toPx(sharedStyles.Spacings.MEDIUM),
}

export const HorizontalSpacer: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: toPx(sharedStyles.Spacings.NODE_HORIZONTAL_PADDING),
  paddingRight: toPx(sharedStyles.Spacings.NODE_HORIZONTAL_PADDING),
}

export const ContentWrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  marginTop: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
}

export const EmptyNodeTextStyle = {
  ...sharedStyles.text,
  ...sharedStyles.textSecondary,
  marginTop: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
  marginBottom: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
}
